// extracted by mini-css-extract-plugin
export var orderDetails = "_o5-2";
export var orderImage = "_o5-1";
export var orderMeta = "_o5-3";
export var orderSummary = "_o5-0";
export var rightArrow = "_o5-4";